import { PlatformName } from './types';

export type FilterHierarchy = 'partner-advertiser' | 'account' | 'advertiser';

export const PLATFORM_FILTER_HIERARCHY: Record<PlatformName, FilterHierarchy> =
  {
    'The Trade Desk': 'partner-advertiser',
    Meta: 'account',
    DV360: 'partner-advertiser',
    TikTok: 'advertiser',
  };

/**
 * Whether a platform organises its entities under an advertiser (vs an
 * account). True for both `partner-advertiser` (TTD, DV360) and `advertiser`
 * (TikTok — advertiser without a partner level). Use this for advertiser-vs-
 * account branching; check `=== 'partner-advertiser'` only when the partner
 * level itself matters.
 */
export const isAdvertiserBasedHierarchy = (platform: PlatformName): boolean =>
  PLATFORM_FILTER_HIERARCHY[platform] !== 'account';

/**
 * Whether a platform exposes the media-plans / audience-library feature set.
 * Drives both the sidebar routes and the media-plan column in trafficking
 * tables. TikTok and DV360 do not support media plans.
 */
export const PLATFORM_SUPPORTS_MEDIA_PLANS: Record<PlatformName, boolean> = {
  'The Trade Desk': true,
  Meta: true,
  DV360: false,
  TikTok: false,
};
